(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ELED-predictive-search"] && !Shopify.designMode) return;
  try {
    var inputs = document.getElementsByClassName("predictive-search__input");
  
  var container = document.getElementById('ELED-predictive-search-container');
  var background = document.getElementById('predictive-search-background');

  // Keyboard navigation of predictive search results
  var selectedItem = null;

  function getColumns() {
    return Array.from(document.querySelectorAll('#ELED-predictive-search-content > div'));
  }

  function getColumnItems(column) {
    return column ? Array.from(column.querySelectorAll('li > a, .predict-article > a')) : [];
  }

  //Select the item by setting the selectedItem variable and adding the currently-selected class
  function selectItem(item) {
    if (selectedItem) {
      selectedItem.classList.remove('currently-selected');
    }
    selectedItem = item;
    if (selectedItem) {
      selectedItem.classList.add('currently-selected');
      selectedItem.scrollIntoView({ block: 'nearest' });
    }
  }

  function clearSelection() {
    selectItem(null);
  }

  window.addEventListener('keydown', function(evt) {
    //Only continue if the predictive search is open
    if (container.style.display !== 'block') {
      return;
    }

    var columns = getColumns();
    if (!columns.length) {
      return;
    }

    //If the up or down arrow key is pressed, change the selected item to be either above or below the current selected item
    if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp') {
      evt.preventDefault();

      var currentColumn = selectedItem ? selectedItem.closest('#ELED-predictive-search-content > div') : columns[0];
      var items = Array.from(document.querySelectorAll("#ELED-predictive-search li > a"));

      if (!items.length) {
        return;
      }

      var index = selectedItem ? items.indexOf(selectedItem) : -1;

      //If the new item would be out of bounds, wrap around to the other side of the column
      if (evt.key === 'ArrowDown') {
        index = index < items.length - 1 ? index + 1 : 0;
      } else {
        index = index > 0 ? index - 1 : items.length - 1;
      }

      selectItem(items[index]);
    //Otherwise, if the left or right arrow key is pressed, change the selected item to be the same index in the column to the left or right
    } else if (evt.key === 'Enter') {
      if (selectedItem) {
        evt.preventDefault();
        window.location.href = selectedItem.href;
      }
    }
  });

  // Clicking outside the search container closes it
  window.addEventListener('click', function(evt) {
    if (!document.querySelector("#ELED-predictive-search").contains(evt.target)) {
      var forms = document.querySelectorAll(".predictive-search__form");
      for(const form of forms) {
        if(form.contains(evt.target) && !evt.target.classList.contains("cancel-search") && !evt.target.classList.contains("drawer__close-button")) {
          return;
        }
      }
      container.style.display = 'none';
      background.style.display = 'none';
      clearSelection();
    }
  });

  // Esc key also closes search
  window.addEventListener('keyup', function(evt) {
    if (evt.keyCode === 27) {
      container.style.display = 'none';
      background.style.display = 'none';
      clearSelection();
    }
  });

  for(const input of inputs) {
    let pauseSearch;
    input.addEventListener("input", async function(e) {

      clearTimeout(pauseSearch);

      //Add a 150ms pause that refreshes when another letter is typed so the search doesn't immediately update
      pauseSearch = setTimeout(function() {
        search(e);
      }, 150);

      function search(evt) {

        var q = evt.target.value;
        var displayedResults = 0;
        
        //Use the search api to get the suggestions for the predictive search
        fetch('/search/suggest.json?q=' + q + '&resources[type]=product,page,article&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor')
          .then(response => response.json())
          .then(async (suggestions) => {
            //If there are no results, hide the predictive search
            if(typeof suggestions.resources === "undefined") {
              container.style.display = 'none';
              background.style.display = 'none';
              clearSelection();
            } else {
              var data = {};
              var resultTypes = Object.entries(suggestions.resources.results);
              var resultCount = 0;
              var firstProduct;
        
              for (const obj of resultTypes) {
                var type = obj[0];
                var results = obj[1];
                resultCount += results.length;

                switch(type) {
                  case 'products':
                    const accessories = ['Parts', 'Accessory', 'single'];     
                    const mainProducts = ['product_main', results.filter(product => !accessories.includes(product.type))];
                    // const secondaryProducts = ['product_accessory', results.filter(product => accessories.includes(product.type))];
      
                    if (mainProducts[1].length > 0 ) {
                      var type_main = type + "_main";
                      firstProduct = mainProducts[1][0];
                      data["autocomplete"] = await buildAutocomplete(q, firstProduct);
                      data[type_main] = buildProducts(mainProducts)
                    }
                    /* if (secondaryProducts[1].length > 0 ) {
                      var type_access = type + "_accessory";
                      data[type_access] = buildProducts(secondaryProducts)
                    } */
                    break;
                  /* case 'collections':
                    data[type] = buildCollections(results);
                    break;
                  case 'pages':
                    data[type] = buildPages(results);
                    break;
                  case 'articles':
                    data[type] = buildArticles(results);
                    break; */
                }
              }

              // Build and append result markup
              var output = buildOutput(data);
              document.getElementById("ELED-predictive-search-content").innerHTML = output;
              clearSelection();
      
              if (resultCount === 0) {
                container.style.display = 'none';
                background.style.display = 'none';
                clearSelection();
              } else if(output !== '') {
                container.style.display = 'block';
                background.style.display = 'block';
              }
      
              var autoGrid = document.querySelector('.predictive-autocomplete-grid')
              var prodGrid = document.querySelector('.predictive-new-grid.product-grid');
              var collectionList = document.querySelector('.predictive-collection-list');
              var pageList = document.querySelector('.predictive-page-list');
              var articleGrid = document.querySelector('.predictive-article-grid');
              
              var newQ = q.replace(/-/g, ' ')
      
              if (newQ.length > 1) {
                const regex = new RegExp(`(${newQ})`, 'gi');
      
                //Surround the unmatched text with <strong> tags
                function highlightTextNodes(node) {
                  if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.nodeValue;
                    const parts = text.split(regex);
      
                    if (parts.length > 1) {
                      const wrapper = document.createElement('span');
                      parts.forEach((part, i) => {
                        if (part === undefined || part === '') 
                          return;
                        // Even indices are non-matched text, odd indices are matched text
                        if (i % 2 === 0) {
                          const strong = document.createElement('strong');
                          strong.textContent = part;
                          wrapper.appendChild(strong);
                        } else {
                          wrapper.appendChild(document.createTextNode(part));
                        }
                      });
                      node.replaceWith(...wrapper.childNodes);
                    }
                    /* Use this for surrounding the MATCHED text with a <strong> tag
                    const newHTML = text.replace(regex, '<strong style="font-size: 16px;">$1</strong>');
                    if (newHTML !== text) {
                      const wrapper = document.createElement('span');
                      wrapper.innerHTML = newHTML;
                      node.replaceWith(...wrapper.childNodes);
                    } */
                  } else if (node.nodeType === Node.ELEMENT_NODE) {
                    node.childNodes.forEach(child => highlightTextNodes(child));
                  }
                }
      
                if (autoGrid) {
                  highlightTextNodes(autoGrid);
                }
                if (prodGrid) {
                  highlightTextNodes(prodGrid);       
                }
                if (collectionList) {
                  highlightTextNodes(collectionList);  
                }
                if (pageList) {
                  highlightTextNodes(pageList);     
                }
                if (articleGrid) {
                  highlightTextNodes(articleGrid);
                }
              }
            }
        });

        function buildProducts(results) {
          var resultsTitle = results[0].split('_')[1];
          results = results[1];
          
          var output = '';
          var markup = '';

      
          if(results.length) {
            for(var i = 0; i < results.length; i++) {
              var product = results[i];
              if(displayedResults >= 9) {
                break;
              }
              markup += `
              <li>
                <a href="${product.url}">${product.title}</a>
              </li>`;
              displayedResults++;
            };
      
            const label = resultsTitle == "main" ? "Products" : "Parts & Accessories";
            output = `
              <div data-type-products-${resultsTitle}>
              <p class="h6 predictive__label">${label}</p>
                <div class="predictive-new-grid product-grid">
                  <ul>
                    ${markup}
                  </ul>
                </div>
              </div>
            `;
          }
    
          return output;
        }
      
        function buildCollections(collections) {
          var output = '';
          var markup = '';
      
          if (collections.length) {
            collections.forEach(collection => {
              markup += `
              <li>
                <a href="${collection.url}">${collection.title}</a>
              </li>`;
            });
      
            output = `
              <div data-type-collections>
                <p class="h6 predictive__label">Collections</p>
                <div class="predictive-new-grid">
                  <ul class="predictive-collection-list no-bullets">
                    ${markup}
                  </ul>
                </div>
              </div>
            `;
          }
    
          return output;
        }
      
        function buildPages(pages) {
          var output = '';
          var markup = '';

          if (pages.length) {
            pages.forEach(page => {
              markup += `
              <li>
                <a href="${page.url}">${page.title}</a>
              </li>`;
            });
      
            output = `
              <div data-type-pages>
                <p class="h6 predictive__label">Pages</p>
                <div class="predictive-new-grid">
                  <ul class="predictive-page-list no-bullets">
                    ${markup}
                  </ul>
                </div>
              </div>
            `;
          }
      
          return output;
        }
      
        // Overwrite full sized image returned form API
        // with lazyloading-friendly path
        function buildArticles(articles) {
          var output = '';
          var markup = '';
      
          if (articles.length) {
            if (articles.length > 4) {
              articles = articles.slice(0, 4);
            }

            articles.forEach(article => {
              if(article.featured_image.url) {
                markup += `
                  <div class="predict-article">
                    <a href="${article.url}">
                      <img src="${article.featured_image.url}" width="75px">
                      <span>${article.title}</span>
                    </a>
                  </div>`;
              } else {
                markup += `
                  <div class="predict-article">
                    <a href="${article.url}">
                      <div class="no-image"></div>
                      <span>${article.title}</span>
                    </a>
                  </div>`;
              }
            });
            
      
            output = `
              <div data-type-articles>
                <p class="h6 predictive__label">Articles</p>
                <div class="predictive-new-grid predictive-article-grid grid grid--uniform grid--no-gutters">
                  ${markup}
                </div>
              </div>
            `;
          }
    
          return output;
        }

        async function buildAutocomplete(q, firstProduct) {
          var output = '';
          var markup = '';
          q = q.replace("&", "and");
          
          //A list of all possible autocomplete searches
          const words = [
            "Retrofit Kits",
            "LED Magnetic Retrofits",
            "LED Tubes",
            "High Bays",
            "Low Bays",
            "High Bays and Low Bays",
            "Panels",
            "Troffers",
            "Panels and Troffers",
            "Downlights",
            "Shop Lights",
            "Strip Lights",
            "Shop and Strip Lights",
            "Exit and Emergency",
            "Flood Lights",
            "Area Lights",
            "Parking Lot Lights",
            "Area and Parking Lot Lights",
            "Wall Packs",
            "Wall Packs and Other Wall Lights",
            "Canopy Lights",
            "Post Top Lights",
            "Bollard Lights",
            "Post Top and Bollard Lights",
            "Solar Lights",
            "Corn Lights",
            "Stadium Lights",
            "Sign Lights",
            "Vapor Tight Lights",
            "Barn Lights",
            "Shoebox Area Lights",
            "Street Lights",
            "Linear Lights",
            "Round/UFO Lights",
            "Cobra Head Lights",
            "Jelly Jar Lights",
            "Hazardous Area Lighting",
            "Halo Lights",
            "High Hat",
            "Disc Lights",
            "Disk Lights",
            "Hazardous Location",
            "Explosion Proof Lights",
            "Marine Grade Lighting",
            "Warehouses",
            "Car Dealerships",
            "Office Buildings",
            "Schools and Education",
            "Healthcare",
            "Retail",
            "Hotels and Hospitality",
            "Sports and Atheletics",
            "Industrial",
            "Multi-Unit Residential",
            "High Ceiling",
            "Landscape and Architectural Accents",
            "Wall Wash",
            "Indoor Lights",
            "Outdoor Lights",
            "Specialized Lights",
            "ELEDLights",
            "RAB",
            "MaxLite",
            "NSF / Sanitation Rated",
            "Ceiling Lights",
            "Cylinder Lights",
            "LED Lamps",
            "Mirror Lights",
            "Recessed Downlights",
            "Wall Sconces",
            "Fluorescent Replacement",
            "U-Bend LED Tube",
            "Metal Halide",
            "HID",
            "Incandescent Replacement",
            "CFL Replacement",
            "Surface Mount",
            "Suspended Grid",
            "Recessed",
            "DLC Listed",
            "DLC Premium Listed",
            "Damp Location",
            "Wet Location",
            "Energy Star",
            "ETL Sanitation",
            "Halogen Replacement",
            "Account",
            "Cancel",
            "Orders",
            "Password",
            "Addresses",
            "Saved",
            "Gift Card",
            "Giftcard",
            "Returns",
            "Replacements",
            "Shipping",
            "Terms",
            "Conditions",
            "Contact",
            "Policies",
            "Warranty",
            "Support",
            "About",
            "Careers",
            "Privacy",
            "Trade Pro Program",
            "Pages",
            "Quantity Pricing Quote",
            "Credit",
            "Rebates and Incentives",
          ];

          const query = q.trim().toLowerCase();

          //Check if the query is within any of the autocomplete searches, and only use the first 10
          const matches = words.filter(word => word.toLowerCase().includes(query)).slice(0, 10);

          //If the query is blank or there are no autocomplete matches, don't show the autocomplete section
          if (!query || matches.length == 0) 
            return;

          const access_token = "44e976014a063c230dfd6b7c3725953b";

          const firstProdQuery = `
            {
              product(id: "gid://shopify/Product/${firstProduct.id}") {
                  metafield(key: "category", namespace: "filter") {
                    value
                  }
              }
            }`;

          const response = await fetch(`https://eledlights1.myshopify.com/api/2026-07/graphql.json`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': access_token
              },
              body: JSON.stringify({ query: firstProdQuery })
          });

          const data = await response.json();

          if(data.data.product.metafield !== null) {
            var firstProdCategory = JSON.parse(data.data.product.metafield.value)[0];
          }

          for(var i = 0; i < matches.length; i++) {
            var elem = matches[i];
            if(i >= 5) {
              break;
            }
            if(i == 0) {
              var searchType = "product";

              //Point the search to the acocunt page
              accountTerms.forEach(function(accountTerm) {
                if(query.includes(accountTerm)) {
                  searchType = "account";
                }
              });

              //Point the search to a page search
              pageTerms.forEach(function(pageTerm) {
                if(query.includes(pageTerm)) {
                  searchType = "page";
                }
              });

              if(searchType == "account") {
                markup += `
                <li class="predict-autocomplete">
                  <a href="/search?type=page&q=${elem}">
                    <span>${elem}</span>
                  </a>
                  <a class="in-category" href="/a/customerhub#account:a:dashboard">in Account</a>
                </li>`;
              } else if(searchType == "page") {
                markup += `
                <li class="predict-autocomplete">
                  <a href="/search?type=${searchType}&q=${elem}">
                    <span>${elem}</span>
                  </a>
                  <a class="in-category" href="/search?type=${searchType}&q=${elem}">in Pages</a>
                </li>`;
              } else {
                markup += `
                <li class="predict-autocomplete">
                  <a href="/search?type=${searchType}&q=${elem}">
                    <span>${elem}</span>
                  </a>
                  <a class="in-category" href="/search?type=${searchType}&q=${elem}&filter.p.m.filter.category=${encodeURIComponent(firstProdCategory)}">in ${firstProdCategory}</a>
                </li>`;
              }
            } else {
              markup += `
                <li class="predict-autocomplete">
                  <a href="/search?type=product&q=${elem}">
                    <span>${elem}</span>
                  </a>
                </li>`;
            }
              displayedResults++;
          };

          output = `
              <div data-type-autocomplete>
                <p class="h6 predictive__label">Popular Searches</p>
                <div class="predictive-new-grid predictive-autocomplete-grid">
                  <ul class="no-bullets">
                    ${markup}
                  </ul>
                </div>
              </div>
            `;

            return output;
        }
      
        // Combine all search result markup and print to page
        function buildOutput(data) {
          var output = '';

          if (data.autocomplete && data.autocomplete !== '') {
            output += data.autocomplete;
          }
    
          if (data.products_main && data.products_main !== '') {
            output += data.products_main;
          }
    
          if (data.products_accessory && data.products_accessory !== '') {
            output += data.products_accessory;
          }
      
          if (data.collections && data.collections !== '') {
            output += data.collections;
          }
      
          if (data.pages && data.pages !== '') {
            output += data.pages;
          }
      
          if (data.articles && data.articles !== '') {
            output += data.articles;
          }
    
          return output;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
